import type { LessonPlan, Level, WordItem } from '../types';

type RawWord = [en: string, uz: string, pos: WordItem['pos']];

const BANKS: Record<string, { level: Level; titleUz: string; titleEn: string; words: RawWord[] }> = {
  introductions: {
    level: 'Pre-A1', titleUz: 'Tanishuv', titleEn: 'Introductions',
    words: [
      ['hello','salom','phrase'],['name','ism','noun'],['meet','uchrashmoq / tanishmoq','verb'],['from','-dan / qayerdan','preposition'],
      ['country','mamlakat','noun'],['city','shahar','noun'],['live','yashamoq','verb'],['speak','gapirmoq','verb'],
      ['language','til','noun'],['friend','do‘st','noun'],['welcome','xush kelibsiz','phrase'],['nice','yoqimli / yaxshi','adjective'],
    ],
  },
  family: {
    level: 'A1', titleUz: 'Oila', titleEn: 'Family',
    words: [
      ['family','oila','noun'],['mother','ona','noun'],['father','ota','noun'],['sister','opa / singil','noun'],
      ['brother','aka / uka','noun'],['child','bola / farzand','noun'],['parents','ota-ona','noun'],['married','turmush qurgan','adjective'],
      ['young','yosh','adjective'],['old','qari / eski','adjective'],['together','birga','adverb'],['relative','qarindosh','noun'],
    ],
  },
  routine: {
    level: 'A1', titleUz: 'Kundalik hayot', titleEn: 'Daily Routine',
    words: [
      ['wake','uyg‘onmoq','verb'],['breakfast','nonushta','noun'],['work','ishlamoq','verb'],['study','o‘qimoq','verb'],
      ['start','boshlamoq','verb'],['finish','tugatmoq','verb'],['morning','ertalab','noun'],['evening','kechqurun','noun'],
      ['usually','odatda','adverb'],['sometimes','ba’zan','adverb'],['always','har doim','adverb'],['sleep','uxlamoq','verb'],
    ],
  },
  home: {
    level: 'A1', titleUz: 'Uy va xonalar', titleEn: 'Home & Rooms',
    words: [
      ['house','uy','noun'],['room','xona','noun'],['door','eshik','noun'],['window','deraza','noun'],
      ['kitchen','oshxona','noun'],['bedroom','yotoqxona','noun'],['bathroom','hammom','noun'],['table','stol','noun'],
      ['chair','stul','noun'],['clean','toza / tozalamoq','adjective'],['inside','ichkarida','adverb'],['outside','tashqarida','adverb'],
    ],
  },
  food: {
    level: 'A1', titleUz: 'Ovqat va ichimlik', titleEn: 'Food & Drink',
    words: [
      ['food','ovqat','noun'],['water','suv','noun'],['bread','non','noun'],['rice','guruch','noun'],
      ['meat','go‘sht','noun'],['fruit','meva','noun'],['vegetable','sabzavot','noun'],['coffee','qahva','noun'],
      ['hungry','och','adjective'],['drink','ichmoq','verb'],['eat','yemoq','verb'],['delicious','mazali','adjective'],
    ],
  },
  time: {
    level: 'A1', titleUz: 'Vaqt va sana', titleEn: 'Time & Dates',
    words: [
      ['today','bugun','adverb'],['tomorrow','ertaga','adverb'],['yesterday','kecha','adverb'],['week','hafta','noun'],
      ['month','oy','noun'],['year','yil','noun'],['hour','soat','noun'],['minute','daqiqa','noun'],
      ['early','erta','adverb'],['late','kech','adverb'],['before','oldin','preposition'],['after','keyin','preposition'],
    ],
  },
  city: {
    level: 'A1', titleUz: 'Shahar', titleEn: 'Around the City',
    words: [
      ['street','ko‘cha','noun'],['shop','do‘kon','noun'],['market','bozor','noun'],['school','maktab','noun'],
      ['hospital','shifoxona','noun'],['bank','bank','noun'],['park','bog‘','noun'],['station','bekat / vokzal','noun'],
      ['near','yaqin','adjective'],['far','uzoq','adjective'],['left','chap','noun'],['right','o‘ng','noun'],
    ],
  },
  travel: {
    level: 'A1', titleUz: 'Sayohat', titleEn: 'Travel',
    words: [
      ['travel','sayohat qilmoq','verb'],['airport','aeroport','noun'],['ticket','chipta','noun'],['passport','pasport','noun'],
      ['hotel','mehmonxona','noun'],['train','poyezd','noun'],['bus','avtobus','noun'],['flight','parvoz','noun'],
      ['arrive','yetib kelmoq','verb'],['leave','jo‘nab ketmoq','verb'],['journey','safar','noun'],['luggage','yuk / bagaj','noun'],
    ],
  },
  work: {
    level: 'A2', titleUz: 'Ish va kasb', titleEn: 'Work & Jobs',
    words: [
      ['job','ish / kasb','noun'],['office','ofis','noun'],['company','kompaniya','noun'],['manager','rahbar','noun'],
      ['team','jamoa','noun'],['project','loyiha','noun'],['meeting','yig‘ilish','noun'],['salary','maosh','noun'],
      ['skill','ko‘nikma','noun'],['experience','tajriba','noun'],['career','karyera','noun'],['professional','professional','adjective'],
    ],
  },
  study: {
    level: 'A2', titleUz: 'Ta’lim', titleEn: 'Study & Learning',
    words: [
      ['learn','o‘rganmoq','verb'],['lesson','dars','noun'],['question','savol','noun'],['answer','javob','noun'],
      ['explain','tushuntirmoq','verb'],['understand','tushunmoq','verb'],['remember','eslamoq','verb'],['practice','mashq qilmoq','verb'],
      ['exam','imtihon','noun'],['result','natija','noun'],['mistake','xato','noun'],['improve','yaxshilamoq','verb'],
    ],
  },
  shopping: {
    level: 'A2', titleUz: 'Xarid', titleEn: 'Shopping',
    words: [
      ['buy','sotib olmoq','verb'],['sell','sotmoq','verb'],['price','narx','noun'],['money','pul','noun'],
      ['cheap','arzon','adjective'],['expensive','qimmat','adjective'],['size','o‘lcham','noun'],['pay','to‘lamoq','verb'],
      ['cash','naqd pul','noun'],['card','karta','noun'],['choose','tanlamoq','verb'],['customer','mijoz','noun'],
    ],
  },
  health: {
    level: 'A2', titleUz: 'Sog‘liq', titleEn: 'Health',
    words: [
      ['health','sog‘liq','noun'],['doctor','shifokor','noun'],['medicine','dori','noun'],['pain','og‘riq','noun'],
      ['sick','kasal','adjective'],['healthy','sog‘lom','adjective'],['exercise','mashq','noun'],['rest','dam olmoq','verb'],
      ['head','bosh','noun'],['body','tana','noun'],['feel','his qilmoq','verb'],['better','yaxshiroq','adjective'],
    ],
  },
  feelings: {
    level: 'A2', titleUz: 'His-tuyg‘ular', titleEn: 'Feelings',
    words: [
      ['happy','xursand','adjective'],['sad','xafa','adjective'],['angry','jahldor','adjective'],['tired','charchagan','adjective'],
      ['excited','hayajonlangan','adjective'],['worried','xavotirlangan','adjective'],['afraid','qo‘rqayotgan','adjective'],['surprised','hayron','adjective'],
      ['calm','xotirjam','adjective'],['hope','umid qilmoq','verb'],['love','sevmoq','verb'],['enjoy','zavqlanmoq','verb'],
    ],
  },
  weather: {
    level: 'A2', titleUz: 'Ob-havo', titleEn: 'Weather',
    words: [
      ['weather','ob-havo','noun'],['sunny','quyoshli','adjective'],['cloudy','bulutli','adjective'],['rain','yomg‘ir','noun'],
      ['snow','qor','noun'],['wind','shamol','noun'],['hot','issiq','adjective'],['cold','sovuq','adjective'],
      ['warm','iliq','adjective'],['temperature','harorat','noun'],['season','fasl','noun'],['forecast','ob-havo ma’lumoti','noun'],
    ],
  },
  technology: {
    level: 'A2', titleUz: 'Texnologiya', titleEn: 'Technology',
    words: [
      ['computer','kompyuter','noun'],['phone','telefon','noun'],['internet','internet','noun'],['website','veb-sayt','noun'],
      ['message','xabar','noun'],['email','elektron pochta','noun'],['password','parol','noun'],['download','yuklab olmoq','verb'],
      ['upload','yuklamoq','verb'],['online','onlayn','adjective'],['device','qurilma','noun'],['digital','raqamli','adjective'],
    ],
  },
  communication: {
    level: 'B1', titleUz: 'Muloqot', titleEn: 'Communication',
    words: [
      ['conversation','suhbat','noun'],['opinion','fikr','noun'],['agree','rozi bo‘lmoq','verb'],['disagree','rozi bo‘lmaslik','verb'],
      ['describe','tasvirlamoq','verb'],['suggest','taklif qilmoq','verb'],['reason','sabab','noun'],['example','misol','noun'],
      ['clearly','aniq ravishda','adverb'],['probably','ehtimol','adverb'],['however','biroq','conjunction'],['because','chunki','conjunction'],
    ],
  },
  nature: {
    level: 'B1', titleUz: 'Tabiat', titleEn: 'Nature',
    words: [
      ['nature','tabiat','noun'],['environment','atrof-muhit','noun'],['tree','daraxt','noun'],['river','daryo','noun'],
      ['mountain','tog‘','noun'],['animal','hayvon','noun'],['protect','himoya qilmoq','verb'],['pollution','ifloslanish','noun'],
      ['energy','energiya','noun'],['climate','iqlim','noun'],['natural','tabiiy','adjective'],['future','kelajak','noun'],
    ],
  },
  business: {
    level: 'B1', titleUz: 'Biznes', titleEn: 'Business',
    words: [
      ['business','biznes','noun'],['client','mijoz','noun'],['service','xizmat','noun'],['product','mahsulot','noun'],
      ['market','bozor','noun'],['profit','foyda','noun'],['cost','xarajat','noun'],['plan','reja','noun'],
      ['decision','qaror','noun'],['growth','o‘sish','noun'],['quality','sifat','noun'],['success','muvaffaqiyat','noun'],
    ],
  },
  culture: {
    level: 'B1', titleUz: 'Madaniyat va jamiyat', titleEn: 'Culture & Society',
    words: [
      ['culture','madaniyat','noun'],['tradition','an’ana','noun'],['community','hamjamiyat','noun'],['history','tarix','noun'],
      ['people','odamlar','noun'],['custom','urf-odat','noun'],['festival','festival / bayram','noun'],['respect','hurmat','noun'],
      ['different','turli','adjective'],['similar','o‘xshash','adjective'],['local','mahalliy','adjective'],['international','xalqaro','adjective'],
    ],
  },
  goals: {
    level: 'B1', titleUz: 'Maqsad va rivojlanish', titleEn: 'Goals & Growth',
    words: [
      ['goal','maqsad','noun'],['progress','rivojlanish','noun'],['habit','odat','noun'],['focus','diqqatni jamlamoq','verb'],
      ['continue','davom ettirmoq','verb'],['challenge','sinov','noun'],['achieve','erishmoq','verb'],['strong','kuchli','adjective'],
      ['consistent','izchil','adjective'],['effort','harakat','noun'],['confidence','ishonch','noun'],['master','mukammal egallamoq','verb'],
    ],
  },
};

const GRAMMAR = [
  'to be: am / is / are',
  'Subject pronouns and possessives',
  'Present Simple',
  'Present Simple: questions and negatives',
  'There is / There are',
  'Articles: a / an / the',
  'Countable and uncountable nouns',
  'Some / any / much / many',
  'Present Continuous',
  'Can / can’t for ability and requests',
  'Past Simple: regular verbs',
  'Past Simple: irregular verbs',
  'Past Simple: questions and negatives',
  'Comparatives and superlatives',
  'Future: be going to',
  'Future: will',
  'Present Perfect: experience',
  'Present Perfect vs Past Simple',
  'Modals: should / must / have to',
  'First Conditional',
  'Relative clauses: who / which / that',
  'Gerunds and infinitives',
  'Passive voice: basic forms',
  'Second Conditional',
  'Reported speech: basic forms',
  'Present Perfect Continuous',
  'Past Continuous',
  'Used to',
  'Linkers: however / although / because',
  'Mixed review and fluency',
];

const topicOrder = Object.keys(BANKS);

function slug(input: string) {
  return input.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
}

function exampleFor(en: string, uz: string, pos: WordItem['pos']): [string, string] {
  const quotedEn = `“${en}”`;
  const quotedUz = `“${uz}”`;
  switch (pos) {
    case 'verb': return [`The verb ${quotedEn} is useful in everyday English.`, `${quotedEn} fe’li ${quotedUz} ma’nosida ishlatiladi.`];
    case 'adjective': return [`The adjective ${quotedEn} describes a quality.`, `${quotedEn} sifati ${quotedUz} ma’nosini beradi.`];
    case 'adverb': return [`The adverb ${quotedEn} adds detail to an action.`, `${quotedEn} ravishi ${quotedUz} ma’nosini beradi.`];
    case 'phrase': return [`Use the phrase ${quotedEn} as one complete chunk.`, `${quotedEn} birikmasini ${quotedUz} ma’nosida yaxlit eslab qoling.`];
    case 'preposition': return [`The preposition ${quotedEn} shows a relationship in a sentence.`, `${quotedEn} predlogi ${quotedUz} ma’nosini ifodalashda ishlatiladi.`];
    case 'conjunction': return [`The conjunction ${quotedEn} connects ideas.`, `${quotedEn} bog‘lovchisi ${quotedUz} ma’nosida fikrlarni bog‘laydi.`];
    case 'pronoun': return [`The pronoun ${quotedEn} can replace a noun in context.`, `${quotedEn} olmoshi kontekstda ${quotedUz} ma’nosini beradi.`];
    default: return [`Learn ${quotedEn} together with its meaning and context.`, `${quotedEn} so‘zini ${quotedUz} ma’nosi va konteksti bilan birga o‘rganing.`];
  }
}

export const WORDS: WordItem[] = Object.entries(BANKS).flatMap(([topic, bank]) =>
  bank.words.map(([en, uz, pos]) => {
    const [exampleEn, exampleUz] = exampleFor(en, uz, pos);
    return {
      id: `${topic}-${slug(en)}`,
      en,
      uz,
      pos,
      exampleEn,
      exampleUz,
      topic,
      level: bank.level,
    } satisfies WordItem;
  }),
);

const wordMap = new Map(WORDS.map((w) => [w.id, w]));

function levelForDay(day: number): Level {
  if (day <= 21) return 'Pre-A1';
  if (day <= 95) return 'A1';
  if (day <= 190) return 'A2';
  if (day <= 300) return 'B1';
  return 'B2';
}

function deepRecallDays(day: number) {
  return [1, 3, 7, 14, 30, 60, 120, 180]
    .map((offset) => day - offset)
    .filter((value) => value > 0);
}

export function getWord(id: string) {
  return wordMap.get(id);
}

export function buildCurriculum(): LessonPlan[] {
  const lessons: LessonPlan[] = [];
  for (let day = 1; day <= 365; day += 1) {
    const topicIndex = Math.floor((day - 1) / 4) % topicOrder.length;
    const topic = topicOrder[topicIndex];
    const bank = BANKS[topic];
    const within = (day - 1) % bank.words.length;
    const newWords = Array.from({ length: 4 }, (_, index) => {
      const raw = bank.words[(within + index) % bank.words.length];
      return wordMap.get(`${topic}-${slug(raw[0])}`)!;
    });

    const priorTopic = topicOrder[(topicIndex - 1 + topicOrder.length) % topicOrder.length];
    const reviewBank = BANKS[priorTopic];
    const reviewWords = Array.from({ length: 4 }, (_, index) => {
      const raw = reviewBank.words[(day + index * 2) % reviewBank.words.length];
      return wordMap.get(`${priorTopic}-${slug(raw[0])}`)!;
    });

    const titleSuffix = day % 7 === 0 ? ' — Boss Battle' : '';
    lessons.push({
      day,
      month: Math.min(12, Math.ceil(day / 30.5)),
      week: Math.ceil(day / 7),
      level: levelForDay(day),
      titleUz: `${bank.titleUz}${titleSuffix}`,
      titleEn: `${bank.titleEn}${titleSuffix}`,
      goalUz: day <= 180
        ? `${bank.titleUz} mavzusida yangi bilim olish va oldingi bilimni faol eslash.`
        : `${bank.titleUz} mavzusida eski bilimni yangi kontekstda tez va erkin ishlatish.`,
      topic,
      grammar: GRAMMAR[(day - 1) % GRAMMAR.length],
      newWords,
      reviewWords,
      isBoss: day % 7 === 0,
      deepRecallDays: deepRecallDays(day),
    });
  }
  return lessons;
}

export const CURRICULUM = buildCurriculum();

export function getLesson(day: number) {
  return CURRICULUM[Math.max(0, Math.min(364, day - 1))];
}

export function getTopicMeta(topic: string) {
  return BANKS[topic];
}
